<template>
  <div class="tw-absolute tw-top-0 tw-right-0 tw-w-156 tw-z-1000 tw-rounded-3xl tw-overflow-hidden tw-bg-white dropdown-shadow" v-if="props.showBag">
    <div class="tw-relative tw-pb-4">
      <div :class="['bag-dropdown tw-overflow-auto lg:tw-pb-0', {'tw-pb-12' : basketStore.basket && basketStore.basket.products && basketStore.basket.products.length > 0}]">
        <OrderDetails />
        <Bag />
        <div class="tw-border-t tw-border-black tw-pt-8 tw-px-8"  v-if="basketStore.basket && basketStore.basket.products && basketStore.basket.products.length > 0">
          <BagTotals />
        </div>
      </div> 
      <div class="tw-absolute tw-bottom-0 tw-z-10 tw-left-0 tw-right-0 tw-bg-gradient-to-b tw-to-white tw-from-white/0 tw-h-24 tw-w-full"  v-if="basketStore.basket && basketStore.basket.products && basketStore.basket.products.length > 0"></div>
    </div>
    <div class="tw-text-center" v-if="basketStore.basket && basketStore.basket.products && basketStore.basket.products.length > 0">
      <router-link
        :to="{ name: 'review-bag'}"
        class="tw-block tw-w-full tw-bg-orange-medium tw-text-white hover:tw-bg-orange-dark hover:tw-text-white tw-uppercase tw-font-bold tw-px-16 tw-py-3 tw-transition-all tw-duration-200" 
        >
        Checkout
      </router-link>
    </div>
  </div>
</template>

<script setup lang="ts">
import { reactive, computed } from 'vue'

import OrderDetails from './_OrderDetails.vue'
import Bag from './_Bag.vue'
import BagTotals from './_BagTotals.vue'
// import { DateTime } from "luxon";

// // Data
import { useBasketStore } from "../../stores/basket";
// import { useUserStore } from '../../stores/user';

// import BagProduct from './_BagProduct.vue';
// import TwButton from '../../components/TwButton.vue'

const props = defineProps<{ showBag: boolean }>();

const basketStore = useBasketStore();
// const userStore = useUserStore();

// const removeProduct = ((bpid: number) => {
//   basketStore.removeProduct(bpid)
// })

</script>

<style scoped>
  .dropdown-shadow {
    box-shadow:  0 13px 12px -2px rgba(0,0,0,0.5);
  }

  .bag-dropdown {
    max-height:  calc(100vh - 190px);
  }
</style>